var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('confirm',{attrs:{"dialog":_vm.commonConfirm,"confirmTitle":_vm.confirmSettings.confirmTitle,"confirmText":_vm.confirmSettings.confirmText,"btns":_vm.confirmSettings.btns,"settingWidth":_vm.width},on:{"pushBtn":function($event){return _vm.closeConfirm($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }